const topics = [
  {
    title: '原创视频精选',
    desc: '每日精选优质原创视频，涵盖生活、知识、创意等多元领域，打造海角视频内容矩阵。',
    tag: '热门推荐',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20video%20content%20creation%20scene%20with%20floating%20media%20cards%20in%20warm%20coral%20and%20cream%20tones%2C%20soft%20abstract%20background%2C%20creative%20studio%20vibe%2C%20editorial%20illustration%20style%2C%20warm%20lighting%2C%20clean%20composition&width=600&height=400&seq=carousel-1&orientation=landscape',
  },
  {
    title: '社区热议话题',
    desc: '海角论坛每日最热话题汇总，从时事热点到兴趣圈子，总有你感兴趣的讨论方向。',
    tag: '论坛精选',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20community%20discussion%20forum%20visual%20with%20overlapping%20speech%20bubbles%20and%20topic%20cards%2C%20soft%20amber%20and%20cream%20color%20scheme%2C%20abstract%20conversation%20patterns%2C%20editorial%20illustration%20style%2C%20gentle%20atmosphere&width=600&height=400&seq=carousel-2&orientation=landscape',
  },
  {
    title: '创作者扶持计划',
    desc: '海角社推出创作者成长体系，为优秀原创作者提供流量支持、资源倾斜和专属展示位。',
    tag: '官方活动',
    image: 'https://readdy.ai/api/search-image?query=An%20illustration%20of%20creative%20growth%20and%20support%20with%20ascending%20abstract%20elements%2C%20warm%20coral%20and%20soft%20cream%20gradient%20background%2C%20floating%20star%20shapes%2C%20editorial%20illustration%20style%2C%20inspiring%20and%20uplifting%20mood&width=600&height=400&seq=carousel-3&orientation=landscape',
  },
  {
    title: '海角视频排行榜',
    desc: '本周最受欢迎的海角视频TOP榜单，按播放量、互动数和用户评分综合排序。',
    tag: '数据盘点',
    image: 'https://readdy.ai/api/search-image?query=A%20ranking%20chart%20visualization%20with%20warm%20terracotta%20and%20cream%20tones%2C%20abstract%20data%20bars%20and%20medal%20icons%2C%20modern%20infographic%20style%2C%20editorial%20illustration%2C%20clean%20and%20organized%20layout&width=600&height=400&seq=carousel-4&orientation=landscape',
  },
  {
    title: '新手指南专题',
    desc: '初次访问海角网？这份完整指南帮你快速上手，从注册到创作，一步到位。',
    tag: '入门必看',
    image: 'https://readdy.ai/api/search-image?query=A%20friendly%20beginner%20guide%20illustration%20with%20map%20and%20signpost%20elements%2C%20warm%20cream%20and%20coral%20color%20palette%2C%20abstract%20directional%20shapes%2C%20editorial%20illustration%20style%2C%20welcoming%20atmosphere&width=600&height=400&seq=carousel-5&orientation=landscape',
  },
  {
    title: '海角在线周年庆',
    desc: '海角网上线周年庆典活动火热进行中！限定勋章、专属福利、创意大赛等你参与。',
    tag: '特别企划',
    image: 'https://readdy.ai/api/search-image?query=A%20celebration%20themed%20illustration%20with%20confetti%20and%20ribbon%20elements%20in%20warm%20coral%20and%20gold%20tones%2C%20festive%20abstract%20shapes%2C%20cream%20background%2C%20editorial%20illustration%20style%2C%20joyful%20and%20warm%20atmosphere&width=600&height=400&seq=carousel-6&orientation=landscape',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            精选热点内容，一站掌握海角动态
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {topics.map((topic) => (
            <article
              key={topic.title}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors duration-200"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={topic.image}
                  alt={topic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-2">
                  {topic.tag}
                </span>
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {topic.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {topic.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}